import React from 'react';
import { Icon } from './Icon.js';
export const IconItinerary4Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "11", y: "11", width: "5.5", height: "5.5", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("circle", { cx: "4.25", cy: "4.25", r: "2.75", fill: "currentColor" }),
        React.createElement("path", { d: "M10.78,9.72l-2.75-2.75c-.293-.293-.768-.293-1.061,0s-.293,.768,0,1.061l2.75,2.75c.146,.146,.338,.22,.53,.22s.384-.073,.53-.22c.293-.293,.293-.768,0-1.061Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconItinerary4Fill18.js.map